import styles from './NotificationsButton.module.scss';
import { useAppDispatch } from '@customer/store/hooks';
import { VdsIconButton } from '@volt/volt-extended-components-react';
import {
  NotificationsSidePanelTab,
  openSidePanel,
  SidePanel,
} from '@customer/store/slices/globalSlice';
import { useGetNotificationsQuery } from '@customer/store/apis/notificationsApi';
import { useCallback } from 'react';

export function NotificationsButton() {
  const dispatch = useAppDispatch();

  const onShowNotificationsPanel = useCallback(() => {
    dispatch(
      openSidePanel({
        sidePanel: SidePanel.Notifications,
        tab: NotificationsSidePanelTab.New,
      }),
    );
  }, [dispatch]);

  const { data } = useGetNotificationsQuery(undefined, {
    refetchOnMountOrArgChange: 600,
  });

  const hasNewNotifications = !!data?.newCount;

  return (
    <VdsIconButton
      className={hasNewNotifications ? styles.badge : ''}
      icon="bell"
      size="medium"
      variant="tertiary"
      onClick={onShowNotificationsPanel}
    />
  );
}

export default NotificationsButton;
